import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { spacing, Text } from '@retailer-platform/shared-components'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { type BannerDestinationValues } from 'domains/banners/types/banner.types'
import { useDashMessages } from 'intl/intl.hooks'

export interface FieldProps {
  destination: Pick<BannerDestinationValues, 'type' | 'target' | 'displayValue'>
}

const rowContainer = css({
  display: 'flex',
  marginBottom: spacing.X24,
})

const textContainer = css({
  width: '90%',
  overflowWrap: 'break-word',
})

export const BannerDetailsLinkDestination: FunctionComponent<FieldProps> = ({ destination }) => {
  const messages = useDashMessages({
    emptyValue: 'bannersDomain.field.empty.value',
    destinationTypeLabel: 'bannersDomain.details.link-destination.destinationType',
    destinationTypeValue: 'bannersDomain.details.link-destination.destinationValue',
  })

  const destinationTypeText = destination?.type ? `${destination.type}` : messages.emptyValue

  const destinationValueText = destination?.displayValue
    ? `${destination.displayValue}`
    : messages.emptyValue

  return (
    <MerchandisingFormSection titleId="bannersDomain.details.link-destination.title">
      <div css={rowContainer}>
        <div css={textContainer}>
          <Text weight="semibold">{messages.destinationTypeLabel}</Text>
          <Text size="medium">{destinationTypeText}</Text>
        </div>
      </div>
      <div css={rowContainer}>
        <div css={textContainer}>
          <Text weight="semibold">{messages.destinationTypeValue}</Text>
          <Text size="medium">{destinationValueText}</Text>
        </div>
      </div>
    </MerchandisingFormSection>
  )
}
